import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Environment, ENVIRONMENT } from '@ld.consumer-portal/models';

export const styleGuideGuard = () => {
  const env = inject<Environment>(ENVIRONMENT);
  const router = inject(Router);

  if (env.appSettings.enableScreenshotGallery === true) {
    return true;
  }

  return router.parseUrl('/dashboard');
};
